import { Text } from '~components/Typography';
import { useTranslations } from '~i18n/hooks';

import { Message } from '../styles';

export const MessageErrorBoundary = ({
	id,
	isUserMessage,
}: {
	id: string;
	isUserMessage: boolean;
}) => {
	const t = useTranslations('Chats');
	return (
		<Message id={id} isMy={isUserMessage}>
			<Text data-name="message-display-error" size="L">
				<i>{t('messageDisplayError')}</i>
			</Text>
		</Message>
	);
};
